import { ApplicationController } from '@aha-app/mvc';
import HasGlobalContainer, {
  type IHasGlobalContainer,
} from 'components/framework/controllers/concerns/HasGlobalContainer';
import ModalAppContainer from './ModalAppContainer';
import Feature from '../framework/models/Feature';
import Epic from '../framework/models/Epic';

type PromoteToWorkspaceModalControllerProps = {};
type PromoteToWorkspaceModalControllerState = {
  records: any;
  showModal: boolean;
};

interface PromoteToWorkspaceModalController extends IHasGlobalContainer {}

@HasGlobalContainer(ModalAppContainer)
class PromoteToWorkspaceModalController extends ApplicationController<
  PromoteToWorkspaceModalControllerState,
  PromoteToWorkspaceModalControllerProps
> {
  static initialState = {
    records: [],
    showModal: false,
  };

  actionInitializeRecords(recordData) {
    const records = recordData.map(record => {
      const Model = record.recordType === 'feature' ? Feature : Epic;
      return new Model({ id: record.id });
    });
    return this.actionSetRecords(records);
  }

  actionSetRecords(records) {
    this.state.records = records;
  }

  actionShowModal() {
    this.state.showModal = true;

    this.renderGlobalContainer();
  }

  actionHideModal() {
    this.state.showModal = false;
  }
}

export const promoteToWorkspaceController =
  new PromoteToWorkspaceModalController();
promoteToWorkspaceController.internalInitialize(null, {});

export default PromoteToWorkspaceModalController;
